(function($){
    'use strict';
    
	$('.js-tile-list-more button').click(function() {
	    $(this).fadeOut(300).closest('.tile-list').find('.tile-list__item').fadeIn(300);
	});
}(jQuery));